import { Button } from "src/elements/buttons";
import { Label } from "src/elements/label";
import { Text } from "src/elements/text";
import { AnswerStates } from "src/Logic/Hooks/useParticipantLogic";
import styled from "styled-components";

const Div = styled.div`
    z-index: 1;
    display:flex;
    flex-direction: column;
    align-items: center;
    margin-top: 60px;

    .categoryLabel {
        margin-bottom: ${ props => props.theme.spacing.small};
    }

    .roundNumber {
        color: var(--white, #FFF);
        text-align: center;
        font-family: var(--font-circular);
        font-size: 24px;
        font-style: normal;
        font-weight: 900;
        line-height: 120%; /* 28.8px */
        text-transform: capitalize;
    }

    .question {
        align-self: stretch;
        color: var(--white, #FFF);
        text-align: center;
        font-family: var(--font-circular);
        font-size: 14px;
        font-style: normal;
        font-weight: 700;
        line-height: 140%; /* 19.6px */
        letter-spacing: 0.14px;
        text-transform: capitalize;
        margin-top: 8px;
        margin-bottom: 16px;
    }
    
    .answeredMessage {
        color: var(--white, #FFF);
        text-align: center;
        font-family: var(--font-circular);
        font-size: 14px;
        font-style: normal;
        font-weight: 700;
        line-height: 140%; /* 19.6px */
        letter-spacing: 0.14px;
        text-transform: capitalize;
    }

    .answerResult {
        color: var(--white, #FFF);
        text-align: center;
        font-family: var(--font-circular);
        font-size: 14px;
        font-style: normal;
        font-weight: 700;
        line-height: 140%; /* 19.6px */
        letter-spacing: 0.14px;
        text-transform: capitalize;
    }
`;

type AnswerType = {
    text: string,
    letter: string,
}

type Props = {
    category?: string,
    answers?: AnswerType[],
    onAnswer?: (value: string ) => void,
    roundNumber: string | number,
    question: string,
    answered: AnswerStates,
}

export const AnswersScreen = ({ answers, category, onAnswer, question, roundNumber, answered }: Props) => {

    const handleAnswerChoose = ( value: string) => { 
        if( onAnswer )
            onAnswer( value)
    }

    console.log(answered)

    return (
        <Div>
            <Label className = "categoryLabel">{ category }</Label>
            <Text className = "roundNumber">{`ROUND ${ roundNumber }`}</Text>
            { answered === AnswerStates.NotAnswered ? <Text className = "question">{ question }</Text> : null }
            { answered === AnswerStates.NotAnswered  ? answers?.map(( answer ) => {
                return <Button className = 'mrBottomSmall' variant="player" onClick = { () => { handleAnswerChoose( answer.letter ) } }>{ answer.text }</Button>
            }) 
            : 
            null }
            { answered === AnswerStates.Waiting ? <Text className = "answeredMessage">Your answer has been sent. Please wait for other players.</Text> : null }
            { answered === AnswerStates.Correct ? <><Text className = "answeredMessage">Congrats!</Text><Text className = "answerResult">Your answer is correct!</Text></> : null}
            { answered === AnswerStates.Wrong ? <><Text className = "answeredMessage">Sorry!</Text><Text className = "answerResult">Your answer is incorrect.</Text></>  : null}

        </Div>
    )
}